import { defineComponent as _defineComponent } from 'vue'
import { useScrollToTop } from "@/composables/shared/useScrollToTop";
import { PropType, ref, toRefs } from "vue";
import InlineSvg from "vue-inline-svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollTopControl',
  props: {
  container: {
    type: Object as PropType<HTMLElement | Window>,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const { container } = toRefs(props);

// 스크롤 대상(ref)
const containerRef = ref<HTMLElement | Window>(container?.value ?? window);

const { isScrollable, isAtTop, scrollToTop } = useScrollToTop(containerRef);

// 클릭 시 스크롤 업
const onClickScrollTopBtn = () => {
  scrollToTop(containerRef.value);
};

const __returned__ = { props, container, containerRef, isScrollable, isAtTop, scrollToTop, onClickScrollTopBtn, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})